<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.date.title' | translate"
  [description]="'organizer.edit.date.description' | translate"
  [isFormValid]="formGroup.valid"
  [isFormDirty]="formGroup.dirty"
  [hasInitialValue]="false"
  [previousUrl]="previousUrl"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="validateForm()"
  [skipSaveModal]="true"
>
  <ng-container [formGroup]="formGroup">
    <app-form-datetime
      formControlName="startDateTime"
      [datePlaceholder]="
        'activity_planning.date_selection.input.date.placeholder' | translate
      "
      [isLive]="isLive"
      [timePlaceholder]="
        'activity_planning.date_selection.input.time.placeholder' | translate
      "
      [minDate]="minDate"
      [defaultValue]="defaultDateTime"
      errorKey="now"
    >
      <ng-container custom-date-label>
        <vtmn-play-icon
          [name]="iconTypeEnum.CalendarDate"
          class="self-center text-base mr-1"
          [height]="18"
          [width]="18"
        ></vtmn-play-icon>
        {{ dateLabel }}
      </ng-container>

      <ng-container custom-time-label>
        <span class="invisible">
          {{ 'activity_planning.date_selection.start_time' | translate }}
        </span>
      </ng-container>

      <ng-container
        *ngIf="isTimezoneSelectionEnabled && isLive"
        custom-timezone-label
      >
        <vtmn-play-icon
          [name]="iconTypeEnum.Earth"
          [height]="18"
          [width]="18"
          class="self-center text-base mr-1"
        ></vtmn-play-icon>
        {{ 'activity_planning.date_selection.timezone' | translate }}
      </ng-container>
    </app-form-datetime>
  </ng-container>
</app-organizer-shared-layout-edit-field>
